// extracted by mini-css-extract-plugin
module.exports = {"filters":"styles_filters__1Y-G-"};